import { ORDER_STATUS, type OrderStatus } from "@evocha/shared-types";
import { LoaderCircle, Check, X, AlertTriangle, Clock, ShieldQuestion } from "lucide-react";

const ICONS = {
  success: Check,
  pending: Clock,
  danger: X,
  info: ShieldQuestion,
  neutral: LoaderCircle,
} as const;

export function StatusBadge({ status, label }: { status: OrderStatus; label?: string }) {
  const meta = ORDER_STATUS[status];
  const Icon = status === "MANUAL_REVIEW" ? AlertTriangle : ICONS[meta.tone];
  return (
    <span className={`ev-badge ev-badge-${meta.tone}`}>
      <Icon size={12} strokeWidth={2.4} aria-hidden />
      {label ?? meta.label.en}
    </span>
  );
}
